
import { mapGetters } from 'vuex'
import promoData from '@/data/promo.json'
import optionsData from '@/data/options.json'

export default {
  name: 'CoursePageHeader',
  computed: {
    ...mapGetters({
      detectedRegion: 'geolocation/region',
      userRegion: 'user/region',
    }),
    // A distinct key per rendered branch so Vue tears down and rebuilds on a
    // branch change instead of patching mismatched subtrees in place.
    branchKey() {
      if (!this.mounted && this.hasPendingCampaign) return 'skeleton'
      return this.activeCampaignSlug || 'default'
    },
    region() {
      return this.userRegion === 'default' ? this.detectedRegion : this.userRegion
    },
    // Check promo.json directly so skeleton only shows when a campaign is genuinely pending
    hasPendingCampaign() {
      // Free product counts as a pending campaign
      if (optionsData.free_offer === '1' && optionsData.freeproduct_id) return true

      const campaign = promoData.activeCampaign
      if (!campaign || !campaign.slug || !campaign.startDate || !campaign.endDate) return false
      const today = new Date().toISOString().slice(0, 10)
      if (today < campaign.startDate || today > campaign.endDate) return false
      if (!Array.isArray(campaign.offers)) return false
      return campaign.offers.some(o => o.offer && o.offer.offerText)
    },
  },
  data() {
    return {
      mounted: false,
      activeCampaignSlug: null,
      campaignBg: 'background: #395674;',
    }
  },
  mounted() {
    if (this.$campaign && this.$campaign.isActive) {
      const offer = this.$campaign.offerForRegion(this.region)

      if (offer === 'free-product') {
        this.activeCampaignSlug = 'free-product'
        this.campaignBg = 'background: #FFBE22;'
        // free product uses the default bg, so no campaignBg change needed
      } else if (offer && offer.offerText) {
        this.activeCampaignSlug = this.$campaign.slug
        const bgMap = {
          'earth-day':    'background: #395674;',
          'flash-sale':   'background: #AD143F;',
          'spring-sale':  'background: #2EA18B;',
          'black-friday': 'background: #1a1a1a;',
          'summer-sale':  'background: #309DB6;',
          'summer-bundles': 'background: #FDE277;',
          'summer-virtual': 'background: #F66385;',
          'summer-finale': 'background: #EC335B;',
        }
        this.campaignBg = bgMap[this.$campaign.slug] || 'background: #395674;'
      }
    }
    this.mounted = true
  },
}
